import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/LeadSource";

export const GetMainPlatforms = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MainPlatforms`, options);

export const CreateMainPlatform = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MainPlatforms`, options);

export const UpdateMainPlatform = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MainPlatforms/:id`, options);

export const DeleteMainPlatform = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MainPlatforms/:id`, options);

export const GetPlatforms = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Platforms`, options);

export const CreatePlatform = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Platforms`, options);

export const UpdatePlatform = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Platforms/:id`, options);

export const DeletePlatform = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Platforms/:id`, options);

export const GetCampaigns = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Campaigns`, options);

export const GetCampaignById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Campaigns/:id`, options);

export const CreateCampaign = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Campaigns`, options);

export const UpdateCampaign = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Campaigns/:id`, options);

export const DeleteCampaign = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Campaigns/:id`, options);

export const GetAdvertisements = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Advertisements`, options);

export const GetAdvertisementById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Advertisements/:id`, options);

export const CreateAdvertisement = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Advertisements`, options);

export const UpdateAdvertisement = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Advertisements/:id`, options);

export const DeleteAdvertisement = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Advertisements/:id`, options);

export const GetSourceKeys = (options) =>
  GENERATE_URL(`${PREFIX_URL}/SourceKeys`, options);

export default {
  GetMainPlatforms,
  CreateMainPlatform,
  UpdateMainPlatform,
  DeleteMainPlatform,
  GetPlatforms,
  CreatePlatform,
  UpdatePlatform,
  DeletePlatform,
  GetCampaigns,
  GetCampaignById,
  CreateCampaign,
  UpdateCampaign,
  DeleteCampaign,
  GetAdvertisements,
  GetAdvertisementById,
  CreateAdvertisement,
  UpdateAdvertisement,
  DeleteAdvertisement,
  GetSourceKeys,
};
